import { apiOphim69Client } from '@/config/api_ophim69';
import { ApiResponse } from '@/types/status';


const OPHIM69_ENDPOINTS = {
    DESCRIPTION_DOMAIN_MOVIE: '/description-domain-movie',

};




export const getPagingPost = async ({
    params = {
        domainIds: [],
        pageIndex: 1,
        pageSize: 10,
        search: "",
    },
}: {
    params: {
        domainIds?: string[];
        pageIndex?: number;
        pageSize?: number;
        search?: string;
    };
}): Promise<ApiResponse<any>> => {
    const queryParams = {
        ...params,
        domainIds: "68e4f8a2e44196de5db161b6"
    };

    return apiOphim69Client.get(
        OPHIM69_ENDPOINTS.DESCRIPTION_DOMAIN_MOVIE + "/get-paging",
        queryParams as any
    );
};

export const callUpdatePost = async (id: string, data: FormData): Promise<ApiResponse<any>> => {
    return apiOphim69Client.put(
        `${OPHIM69_ENDPOINTS.DESCRIPTION_DOMAIN_MOVIE}/${id}`,
        data as any
    );
};

export const callCreatePost = async (data: { domain_id: string; movie_id: string; }): Promise<ApiResponse<any>> => {
    return apiOphim69Client.post(
        `${OPHIM69_ENDPOINTS.DESCRIPTION_DOMAIN_MOVIE}`,
        data as any
    );
};

export const callCreatePostBulk = async (data: { domain_ids: string[]; movie_ids: string[]; }): Promise<ApiResponse<any>> => {
    return apiOphim69Client.post(
        `${OPHIM69_ENDPOINTS.DESCRIPTION_DOMAIN_MOVIE}/bulk`,
        data as any
    );
};

export const callDeletePost = async (id: string): Promise<ApiResponse<any>> => {
    return apiOphim69Client.delete(
        `${OPHIM69_ENDPOINTS.DESCRIPTION_DOMAIN_MOVIE}/${id}`
    );
};
